GP.GPMod('PremiumChangePrice',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;

    var _data = {
        // default prices in credits
        price_range: {
            min: 4,
            max: 200
        },
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            _data.price_range = {
                min: 4,
                max: 200
            };
        },

        duid: null,
        premium_content_id: null,

        item_price: null,
        item_previous_price: null
    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_viewer", events.setup_viewer);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
        },
        setup_viewer: function() {
            if (
                typeof premium_change_price_content !== 'undefined'
                && premium_change_price_content
            ) {
                _data.duid = premium_change_price_content.duid;
                _data.premium_content_id = premium_change_price_content.premium_content_id;

                _data.item_price = _data.item_previous_price = parseInt(premium_change_price_content.credits);

                $('#info').html('(please choose a selection between ' + _data.price_range.min + ' and ' + _data.price_range.max + ')');
                $('#premium_content_price').val(_data.item_price);
            }

            $('#btn_premium_change_price').on('click', function(e) {
                $('.premium-change-price-modal .alert-success').hide();
                $('.premium-change-price-modal .alert-error').hide();

                var price = parseInt($('#premium_content_price').val());
                if (price == _data.item_previous_price) {
                    events.show_error('New price is the same as the old price');
                    return false;
                }
                if (price < _data.price_range.min || price > _data.price_range.max) {
                    events.show_error('Please enter a value between ' + _data.price_range.min + ' and ' + _data.price_range.max);
                    if (price < _data.price_range.min) {
                        $('#premium_content_price').val(_data.price_range.min);
                    } else {
                        $('#premium_content_price').val(_data.price_range.max);
                    }
                    return false;
                }
                $.post('/members/premium/change_price_modal', {
                    duid               : _data.duid,
                    premium_content_id : _data.premium_content_id,
                    price              : price,
                    process            : 1
                })
                .done(function(json) {
                    if (json.status) {
                        _data.item_price = _data.item_previous_price = price;
                        $('#premium-price-' + _data.premium_content_id).html(price + ' credits');
                        events.show_success();
                    } else {
                        events.show_error(json.error);
                    }
                });
            });
        },
        show_success: function() {
            $('.premium-change-price-modal .alert-success').show();
            setTimeout(function() {
                $('.premium-change-price-modal .alert-success').fadeOut();
                // close the modal
                vent.trigger('Modal:close');
            }, 1000);
        },
        show_error: function(text_error) {
            $('.premium-change-price-modal .alert-error')
            .text(text_error)
            .show()
            .delay(1000)
            .fadeOut();
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
    });
});
